// screen size
export enum ScreenSize {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
}

// toast type
export enum ToastType {
  success,
  failure,
  warning,
}
